import { render, staticRenderFns } from "./FamilyLawStep.vue?vue&type=template&id=58ff483c"
import script from "./FamilyLawStep.vue?vue&type=script&lang=ts"
export * from "./FamilyLawStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports